export default {
  eventsTimestamp(state) {
    return state.eventsTimestamp;
  },
  events(state) {
    return state.events;
  },
};
